import { Directive, ElementRef, OnInit, inject } from '@angular/core';

@Directive({
    selector: 'vwui-table:not([breakpoint])',
    standalone: false
})
export class VwuiTableDefaultBreakpointDirective implements OnInit {
    private elementRef = inject<ElementRef<HTMLVwuiTableElement>>(ElementRef);


    ngOnInit() {
        this.elementRef.nativeElement.setAttribute('breakpoint', 'xs');
    }

}
